import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section aria-labelledby="painpoints-title" className="bg-brand-sand px-4 py-20 md:py-28" data-id="element-195" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-6xl text-center" data-id="element-196" data-mp="2wpt3knojpw7r">
        <h2 id="painpoints-title" className="text-3xl font-extrabold tracking-tight text-brand-navy md:text-4xl" data-id="element-197" data-mp="2rq83ub1jxjtz">
          Vous vous reconnaissez&nbsp;?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-slate-600" data-id="element-198" data-mp="35nmtngvpvtmh">
          Préparer une séance ne devrait pas prendre toute votre soirée.
        </p>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-199" data-mp="3ffskgna8g503">
          {painPoints.map(({
          title,
          description
        }, index) => <article key={title} className="flex flex-col rounded-2xl bg-white p-6 text-left shadow-sm md:p-7" data-id="element-200" data-mp="3ahr5oejuaruf" data-mpi={index}>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-navy text-sm font-bold text-white" data-id="element-201" data-mp="3ogh0fnj6sffm">
                {index + 1}
              </span>
              <h3 className="mt-5 text-lg font-bold leading-snug text-brand-navy" data-id="element-202" data-mp="sw329b0uwa1z">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-203" data-mp="wxeiipxubixi">{description}</p>
            </article>)}
        </div>
        <p className="mt-12 text-2xl font-bold italic text-brand-teal" data-id="element-204" data-mp="11xj3ot9p11u2">
          Vous méritez des ressources qui vous facilitent la préparation.
        </p>
      </Reveal>
    </section>;
}